import { tagsApiResponseSchema, Tag } from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';

export async function getAllTags(): Promise<Tag[]> {
	const { body } = await clientRequest.get(`/api/tags?noPagination=true`, {
		schema: tagsApiResponseSchema,
	});
	return body.data;
}
